import { render } from "./SidemenuCarrierItem.vue?vue&type=template&id=69b5fe88"
import script from "./SidemenuCarrierItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidemenuCarrierItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/partials/SidemenuCarrierItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69b5fe88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69b5fe88', __exports__)) {
    api.reload('69b5fe88', __exports__)
  }
  
  module.hot.accept("./SidemenuCarrierItem.vue?vue&type=template&id=69b5fe88", () => {
    api.rerender('69b5fe88', render)
  })

}


export default __exports__